import { FieldValues, useForm, UseFormProps } from 'react-hook-form';

export const useCorlForm = <T extends FieldValues>(formConfig: UseFormProps<T>) => {
  const methods = useForm<T>({
    shouldFocusError: true,
    criteriaMode: 'all',
    mode: 'onBlur',
    reValidateMode: 'onChange',
    ...formConfig,
  });

  return methods;
};
